module.exports = __webpack_public_path__ + "static/media/celery.87b67f20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/celery.svg
// module id = 1127
// module chunks = 0